import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleUser, faGear } from "@fortawesome/pro-duotone-svg-icons";
import SettingsIcon from '@material-ui/icons/Settings';
import HomeIcon from '@material-ui/icons/Home';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import { getMenuConfig } from '../../utils/menuNavigationHelper';
import { isSmallerThanScreenX, isIOS } from '../../utils';
import * as storage from '../../utils/storage';
import { IsEnglish } from '../../utils/language';
import * as keyMenu from '../../scripts/KeyMenu';
import i18next from 'i18next';
import * as TypeHelpOnline from '../../scripts/TypeHelpOnline'


const useStyles = makeStyles(theme => ({
    divNavigationReset: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        top: '1000px',
        textAlign: '-webkit-center',
        transition: 'top 0.3s ease 0.3s',
        backgroundColor: '#f5f5f5',
        zIndex: 9998,
    },
    divNavigation: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        textAlign: '-webkit-center',
        transition: 'top 0.3s ease 0.3s',
        backgroundColor: '#f5f5f5',
        zIndex: 11001
    },
    divAvatar: {
        backgroundColor: '#f5f5f5',
        marginRight: 'auto',
        float: 'left',
        width: 'calc(100% - 30px)',
        margin: '15px',
    },
    divIcon: {
        textAlign: 'left',
        color: 'var(--color1)',
        float: 'left',
        marginTop: '5px',
        '& > svg': {
            width: '50px',
            height: '50px'
        }
    },
    divUser: {
        float: 'left',
        display: 'table',
        color: 'var(--color4)',
        marginLeft: '5px',
        marginTop: '6px',
        '& > span': {
            display: 'table',
            width: '210px',
            textAlign: 'left'
        }
    },
    spanUserCode: {
        fontSize: '12px',
        fontWeight: 'bold'
    },
    spanUserName: {
        fontWeight: 'bold'
    },
    divSettings: {
        float: 'right',
        margin: '4px'
    },
    divRootButtons: {
        display: 'table',
        width: 'calc(100% - 20px)',
    },
    divButton: {
        display: 'table',
        borderRadius: '8px',
        backgroundColor: 'var(--color2)',
        padding: '15px 15px 12px 15px',
        boxShadow: '0px 0px 4px 1px #c2c2c27a',
        float: 'left',
        width: 'calc(50% - 14px)',
        margin: '7px',
        cursor: 'pointer',
        '& > svg': {
            display: 'table',
            width: '100% !important'
        },
        color: '#818181',
        fontWeight: 'bold',
        fontSize: '15px',
        border: '1px solid #c7c7c7a8',
        textAlign: 'center'
    },
    divClose: {
        bottom: '-8px',
        right: '10px',
        position: 'absolute',
    },
    divCloseIOS: {
        bottom: '0px',
        right: '0px',
        position: 'absolute',
    },
    divLabelMenu: {
        display: 'table',
        width: 'calc(100% - 20px)',
        textAlign: 'left',
        marginLeft: '15px',
        marginBottom: '10px',
        fontWeight: 'bold',
        fontVariant: 'all-small-caps',
        fontSize: '22px'
    },
    divSeparator: {
        display: 'table',
        width: 'calc(100% - 20px)',
        '& > hr': {
            backgroundColor: '#adadad',
            marginTop: '5px',
            height: '2px',
            borderRadius: '20px'
        }
    },
    divAlignButtons: {
        width: '100%',
        overflow: 'auto'
    },
    divScrollSign: {
        backgroundColor: '#c0c0c0',
        borderRadius: '12px',
        width: '26%',
        height: '5px',
        marginTop: '15px'
    },
    divScrollSignIOS: {
        backgroundColor: '#c0c0c0',
        borderRadius: '12px',
        width: '26%',
        height: '5px',
        marginTop: '5px'
    }
}));


function MenuNavigation(props) {
    const classes = useStyles();
    const [Css, setCss] = useState(classes.divNavigationReset);
    const [menus, setMenus] = useState([]);
    const [userCode, setUserCode] = useState(storage.getUserCode());
    const [userName, setUserName] = useState(storage.getUserName());
    const [useAbbreviation, setUseAbbreviation] = useState(false);

    const isiOS = isIOS();

    useEffect(() => {
        loadMenu();
        resizeMenu();
        setUseAbbreviation(isSmallerThanScreenX(500));
    }, []);

    useEffect(() => {
        if (props.showAllMenu) {
            // setTimeout just to fix the animation
            setTimeout(() => { setCss(classes.divNavigation) }, 0);
        }
    }, [props.showAllMenu]);

    useEffect(() => {
        // This is to close the menu (all) when we select the menu from de favotire's menu
        if (props.closeAllMenu) {
            setCss(classes.divNavigationReset);
        }
    }, [props.closeAllMenu]);

    const resizeMenu = () => {
        setTimeout(() => {
            const heightWindow = window.innerHeight;
            const menu = document.querySelector('#menuFavorite').clientHeight;
            const offSet = 210;
            const customHeight = heightWindow - menu - offSet;
            const customNavigationHeight = heightWindow - menu;

            const element = document.querySelector("#divMenu");
            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }

            const elementNavigation = document.querySelector("#divNavigation");
            if (elementNavigation !== undefined && elementNavigation !== null) {
                elementNavigation.style.height = `${customNavigationHeight}px`;
            }

            const elementDivScroll = document.querySelector("#divScrollSign");
            elementDivScroll.style.display = "none";

            if (element.scrollHeight > element.clientHeight) {
                // has scroll
                if (elementDivScroll !== undefined && elementDivScroll !== null) {
                    elementDivScroll.style.display = "block";
               }
            }
        }, 250);
    }

    const loadMenu = () => {
        let menus = storage.getMenu();
        menus = JSON.parse(menus).filter(x => !x.isTab);

        let menusFormatted = [];

        if (menus) {
            menus.forEach(item => {
                const menuConfig = getMenuConfig(item.codeMenu);
                menusFormatted.push({ item, menuConfig });
            });
            setMenus(menusFormatted);
        }
    }

    const handleCloseMenu = () => {
        setCss(classes.divNavigationReset);
        setTimeout(() => {
            props.handleShowAllMenu(false);
        }, 1000);
    }

    const handleLoadPage = (id) => {
        localStorage.setItem('knkmob.selectedMenu', id);
        props.handleSelectedPage(id)
        setCss(classes.divNavigationReset);
        setTimeout(() => {
            props.handleShowAllMenu(false);
        }, 1500);
    }

    const handleLegalInformation = (typeInfo) => {
        props.handleLegalInfo(typeInfo);
    }

    const cssDivClose = isiOS ? classes.divCloseIOS : classes.divClose;

    const cssDivScrollSign = isiOS ? classes.divScrollSignIOS : classes.divScrollSign;

    return (
        <div id="divNavigation" className={Css}>
            <div className={classes.divAvatar}>
                <div className={classes.divIcon}>
                    <FontAwesomeIcon icon={faCircleUser} style={{ color: 'var(--color1)' }} />
                </div>
                <div className={classes.divUser}>
                    <span className={classes.spanUserCode}>
                        {userCode}
                    </span>
                    <span className={classes.spanUserName}>
                        {userName}
                    </span>
                </div>
                <div className={classes.divSettings}>
                    <IconButton style={{ color: 'var(--color1)' }} aria-label={i18next.t('menu:settings')} component="span" onClick={() => handleLoadPage(keyMenu.MENU_SETTINGS)}>
                        <FontAwesomeIcon icon={faGear} style={{ color: 'var(--color1)' }} />
                    </IconButton>
                </div>
            </div>
            <div className={classes.divSeparator}>
                <hr />
            </div>
            <div className={classes.divRootButtons}>
                <div className={classes.divLabelMenu}>Menus</div>

                <div id="divMenu" className={classes.divAlignButtons}>
                    <div className={classes.divButton} onClick={() => handleLoadPage(keyMenu.MENU_HOME)}>
                        <HomeIcon style={{ color: '#528d80' }} />
                        <span>{i18next.t('menu:home')}</span>
                    </div>
                    {menus && menus.map((obj, index) =>
                        <div key={index} className={classes.divButton} onClick={() => handleLoadPage(`${obj.menuConfig.id}`)}>
                            {obj.menuConfig.icon }
                            <span>{IsEnglish() ? (useAbbreviation && obj.menuConfig.descriptionAbbrE !== '' ? obj.menuConfig.descriptionAbbrE : obj.item.descriptionEnglish)
                                : (useAbbreviation && obj.menuConfig.descriptionAbbrF !== '' ? obj.menuConfig.descriptionAbbrF : obj.item.descriptionFrench)}</span>
                        </div>
                    )}
                </div>
                <div id="divScrollSign" className={cssDivScrollSign}>
                    &nbsp;
                </div>
            </div>
            <div className={cssDivClose}>
                <IconButton aria-label="Fermer menu" component="span" onClick={handleCloseMenu}>
                    <CloseIcon />
                </IconButton>
            </div>
            <div className="divRootTerms">
                {storage.getLegalInfo() !== null && storage.getLegalInfo().length > 0 && <div style={{float: 'left'}}><a className="legalInformation" onClick={() => handleLegalInformation(TypeHelpOnline.Legal_Information)}>{i18next.t('menu:privacyPolicy')}</a></div>}
                {storage.getTermsUse() !== null && storage.getTermsUse().length > 0 && <div style={{ float: 'left', marginLeft: '15px' }}><a className="legalInformation" onClick={() => handleLegalInformation(TypeHelpOnline.TermsUse_Information)}>{i18next.t('menu:termsUse')}</a></div>}
            </div>
        </div>
    );
}

export default withNamespaces(['login', 'menu'], { wait: true })(MenuNavigation);